import React, { useEffect, useState } from 'react'
import { ScrollParentContext, WINDOW_SCROLL } from '../../context/ScrollParentContext';
import { SLayout, SMain } from './styles';
import HeaderLayout from '../Header/HeaderLayout';
import UserOnboarding from '../UserOnboarding/UserOnboarding';
import EmailVerificationModal from '../Auth/EmailVerificationModal';
import ImpersonationBanner from '../ImpersonationBanner/ImpersonationBanner';
import { useNavigation } from '../../context/NavigationContext';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from 'react-router-dom';

//import Debug from '../Debug';
//import TestNav from '../TestNav';

const DESKTOP_QUERY = '(min-width: 769px)';

const Layout = ({children}) => {
  const { hideBottomNavigation } = useNavigation();
  // On desktop the main panel scrolls; on phones the page itself does. Virtualized lists use this.
  const [mainEl, setMainEl] = useState(null);
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(DESKTOP_QUERY).matches);
  useEffect(() => {
    const query = window.matchMedia(DESKTOP_QUERY);
    const onChange = (e) => setIsDesktop(e.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);
  const { currentUser } = useAuth();
  const location = useLocation();
  
  // Show verification modal if user is logged in, not verified, and not on verification page
  const showVerificationModal = currentUser && 
                                  !currentUser.emailVerified && 
                                  location.pathname !== '/verify-email';
  
  return (
    <SLayout>
      <ImpersonationBanner />
      <HeaderLayout />
      <UserOnboarding />
      <SMain ref={setMainEl} $hideBottomNavigation={hideBottomNavigation}>
        <ScrollParentContext.Provider value={isDesktop ? mainEl : WINDOW_SCROLL}>
          {children}
        </ScrollParentContext.Provider>
      </SMain>
      {showVerificationModal && (
        <EmailVerificationModal email={currentUser.email} />
      )}
      {/* <TestNav /> {/* Add the test component
      <Debug /> */}
    </SLayout>
  );
};

export default Layout